export default __webpack_public_path__ + "static/media/5.a630397b.png";